const version = '2.5.12';
export { version };
